import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';
import TextField from '@material-ui/core/TextField';
import Confirm from '../Confirm';

const ConfirmReason = function ({
    placeholder,
    reasonMaxSize,
    reasonMinSize,
    okButtonDisabled,
    handleClose,
    ...props
}) {

    const classes = useStyles();
    const [reason, setReason] = useState('');

    function onClose(option = false) {
        handleClose && handleClose(option, reason);
        setReason('');
    }

    const hdlInput = (value) => {
        if (value.length < reasonMaxSize) {
            setReason(value);
        }
    }

    const okDisabled = _ => okButtonDisabled || (!reason || reason.length < reasonMinSize);

    return (
        <Confirm
            {...props}
            handleClose={onClose}
            okButtonDisabled={okDisabled()}
        >
            <TextField
                variant="outlined"
                className={classes.reasonField}
                data-cy="reason-modal-field"
                id="reason-modal-field"
                onChange={e => hdlInput(e.target.value)}
                value={reason}
                placeholder={placeholder}
            />
        </Confirm>
    );
};

ConfirmReason.defaultProps = {
    okButtonDisabled: false,
    reasonMaxSize: 180,
    reasonMinSize: 10,
}

ConfirmReason.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func,
    okText: PropTypes.string,
    okButtonDisabled: PropTypes.bool,
    cancelText: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    placeholder: PropTypes.string,
    reasonMaxSize: PropTypes.number,
    reasonMinSize: PropTypes.number,
};

export default ConfirmReason;